<template>
  <div class="web">
    <Header :type="'home'"></Header>
      <!-- HERO 1  -->
    <div class="hero position-relative home" :style="{ 'background-image': 'url(' + urlWeb + '/assets/images/bg/home_itsapp.png)'}">
          <div class="overlay-light"></div>
          <div class="container d-flex flex-column" :style="{ 'background-image': 'url(' + urlWeb + '/assets/images/vectors/home_hero_bg.svg)'}">
            <div class="col-12">
                <h1 class="mb-4 main-text">
                  <span class="text-blue">
                    UN MUNDO DE<br/>CONSULTORIA</span> 
                  <span class="text-orange">A UN CLICK</span>
                </h1>
                <h4 class="text-orange hero-title">Determine the SAP application platform to work with</h4>
                <p class="hero-paragraph">
                  Conectamos empresas y consultores independientes, para dar soluciones personalizadas,
                  eficientes y económicas en las diferentes tecnologías de SAP.
                </p>
            </div>
            <div class="mb-4 container-bottom hero-footer"> 
              SAP y otros productos y servicios de SAP mencionados en esta página web, así como sus
              respectivos logotipos, son marcas comerciales o marcas registradas de SAP SE (o una empresa filial
              de SAP) en Alemania y en otros países.
            </div>
          </div>
      </div>

   

    <div class="container-fluid" hidden>
      <br>
      <button class="btn btn-small btn-primary" @click="testAPI">Probar Api</button>
      <button class="btn btn-small btn-secondary" @click="Reset">Reset BD</button>
      <button class="btn btn-small btn-danger" @click="sendEmail">Email Test</button>
      <br><br>
    </div>

  </div>
</template>


<script>
import Header from '@/components/Header'
import { mapState } from 'vuex'
export default {
  computed:{
    ...mapState(['urlWeb'])
},
name: 'Home',
components:{
      Header
},
data () {
  return {
    sesion: false,
    band_home: false,
    url: 'https://itsapp.com.mx/api/php/'
    //url: 'http://localhost/itsapp/api/php/'
  }
},
methods:{
testAPI(){
  this.axios.post(this.url + "testApi.php").then((responce) => {
      console.log(responce.data);
  });
},
Reset(){
  this.axios.post(this.url + "resetBD.php").then((responce) => {
      console.log(responce.data);
      if(responce.data==200){
        alert("BD Limpiada");
      }
  });
},
sendEmail(){
  let data = {
    template: 13,
    subject: "Propuesta recibida",
    idProyecto: 5,
    idPropuesta: 1
  }

  /*data = {
    flag: 1
  }*/

  this.axios.post(this.url + "sendEmailAviso.php", data).then((responce) => {
      console.log(responce);
      if(responce.status == 200) {
        alert("Correo Enviado con Exito");
      }
      else{
        alert("Error!");
      }
  });
}
}
}
</script>


<style scoped>
.big-banner
{
  background-image: url('../../assets/img4.jpg');
  background-size: 100%;
  height: 500px;
  padding-top: 150px;
}

.section-title {
  padding-bottom: 40px;
}

.section-title h2 {
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  line-height: 1px;
  margin: 0 0 5px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #aaaaaa;
  font-family: "Poppins", sans-serif;
}

.section-title h2::after {
  content: "";
  width: 120px;
  height: 1px;
  display: inline-block;
  background: #e6636a;
  margin: 4px 10px;
}

.section-title p {
  margin: 0;
  margin: 0;
  font-size: 36px;
  font-weight: 700;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  color: #556270;
}

.icon-box {
  margin-bottom: 20px;
  padding: 30px;
  border-radius: 6px;
}

.icon-box i {
  float: left;
  color: #d9232d;
  font-size: 40px;
}

.icon-box h4 {
  margin-left: 70px;
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

.icon-box h4 a {
  color: #556270;
  transition: 0.3s;
}

.icon-box p {
  margin-left: 70px;
  line-height: 24px;
  font-size: 14px;
}

.icon-box:hover h4 a {
  color: #d9232d;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue